// extracted by mini-css-extract-plugin
module.exports = {"ContinueButtonRow":"OrderHandler_ContinueButtonRow__2iU1m","ContinueOrderButton":"OrderHandler_ContinueOrderButton__1uChe"};